export default __webpack_public_path__ + "static/media/ars-maquette-medium-webfont.76fcb6aa.ttf";